import React from 'react';
import { EventEmitter } from 'events';

import ObservApi from '../../lib/observable-api.js';
import DomainStore from './DomainStore';
import CategoryListingStore from './categories/CategoryListingStore';
import EncoderListingStore from './encoders/Store';
import DomainContainer from './DomainContainer';

export default function (domainName, api, socket) {
    var socketBus = new EventEmitter();

    socket[domainName](function onData (data) {
        // console.log('socket.%s – [%s:%s] – %o', domainName, data.action.method, data.action.type, data.data);
        if (data.action.type == 'update') data.action.type = 'edit';
        socketBus.emit(data.action.type, data);
    });

    var domainApi = ObservApi(api);

    var domainStore;
    switch (domainName) {
        case 'categories':
            domainStore = CategoryListingStore(domainApi.bus, socketBus);
            break;

        case 'encoders':
            domainStore = EncoderListingStore(domainApi.bus, socketBus);
            break;

        default:
            domainStore = DomainStore(domainName, domainApi.bus, socketBus);
    }

    var state = window.domainState = domainStore.state;
    var actions = domainApi.actions;
    return props => {
        return <DomainContainer {...props}
            domainName={domainName}
            store={state}
            actions={actions}
        />
    }
}
